import { AGENT_SELECTED_BOT_STORAGE_KEY } from '@/constants/agentWorkspace';

/** Zustand persist key — must match `name` in auth.store.ts */
const AUTH_PERSIST_KEY = 'auth-storage';

/**
 * Clears JWT keys and the zustand auth persist entry so in-memory/router state
 * cannot disagree after session invalidation (e.g. axios 401 handler).
 */
export function clearAuthClientStorage(): void {
  try {
    localStorage.removeItem('auth_token');
    localStorage.removeItem('refresh_token');
    localStorage.removeItem(AUTH_PERSIST_KEY);
    localStorage.removeItem(AGENT_SELECTED_BOT_STORAGE_KEY);
  } catch {
    // ignore (storage unavailable)
  }
}
